export default __webpack_public_path__ + "static/media/Group 3538.47912959.jpg";